import React, { useState, useEffect } from "react";
import axios from "axios";
import { REACT_APP_API_URL } from "../../../../../env";

const UploadDocumentsForm = () => {
  const [unitTypeId, setUnitTypeId] = useState("1");
  const [propertyTypeId, setPropertyTypeId] = useState("");
  const [propertyId, setPropertyId] = useState("");
  const [roomTypeId, setRoomTypeId] = useState("");
  const [documentType, setDocumentType] = useState("photo");
  const [photoTypeId, setPhotoTypeId] = useState("1");
  const [docTypeId, setDocTypeId] = useState("1");
  const [description, setDescription] = useState("");
  const [isDefault, setIsDefault] = useState(1);
  const [file, setFile] = useState(null);
  const [unitTypes, setUnitTypes] = useState([]);
  const [unitNames, setUnitNames] = useState([]);
  const [roomTypes, setRoomTypes] = useState([]);
  const [selectedUnit, setSelectedUnit] = useState("Hotel");

  useEffect(() => {
    axios.get(`${REACT_APP_API_URL}api/property/unit-types`).then((res) => {
      if (res.data.success) {
        setUnitTypes(
          res.data.data.map((type) => ({
            id: type.PropertyTypeID,
            name: type.PropertyTypeName,
          }))
        );
      }
    });
  }, []);

  useEffect(() => {
    axios.get(`${REACT_APP_API_URL}api/property/units`).then((res) => {
      if (res.data.success) {
        setUnitNames(
          res.data.data.map((unit) => ({
            id: unit.PropertyID,
            name: unit.UnitName,
          }))
        );
      }
    });
  }, []);

  useEffect(() => {
    if (selectedUnit === "Room" && propertyId) {
      axios
        .post(`${REACT_APP_API_URL}api/property/get-unit-types`, {
          P_CHRACTION: "RT",
          P_INTPROPERTYID: propertyId,
        })
        .then((res) => {
          if (res.data.success) {
            setRoomTypes(res.data.data);
          }
        });
    }
  }, [selectedUnit, propertyId]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append("P_intUnitTypeID", unitTypeId);
    formData.append("P_intDefault", isDefault);
    formData.append("P_intPropertyID", propertyId);
    formData.append("P_intRoomTypeId", roomTypeId || 0);
    formData.append("P_vchDocumentType", documentType);
    formData.append("P_vchDescription", description);
    formData.append("P_INTCREATEDBY", 1);
    formData.append("P_intPropertyTypeId", propertyTypeId);
    formData.append("P_intPhotoTypeID", photoTypeId);
    formData.append("P_intDocumentType", docTypeId);
    if (file) formData.append("photo", file);

    try {
      const res = await axios.post(`${REACT_APP_API_URL}api/property/upload`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });
      alert(res.data.message || "Upload successful");
    } catch (err) {
      console.error("Upload failed:", err);
      alert("Upload failed.");
    }
  };

  return (
    <div className="container mt-4">
      <div className="card shadow">
        <div className="card-header bg-primary text-white">
          <h3 className="mb-0">Upload Property Document</h3>
        </div>
        <div className="card-body">
          <form onSubmit={handleSubmit}>
            <div className="row mb-3">
              <div className="col-md-4">
                <label className="form-label">Unit</label><br />
                <div className="form-check form-check-inline">
                  <input type="radio" value="1" className="form-check-input" checked={unitTypeId === "1"} onChange={() => { setUnitTypeId("1"); setSelectedUnit("Hotel"); }} />
                  <label className="form-check-label">Hotel</label>
                </div>
                <div className="form-check form-check-inline">
                  <input type="radio" value="2" className="form-check-input" checked={unitTypeId === "2"} onChange={() => { setUnitTypeId("2"); setSelectedUnit("Room"); }} />
                  <label className="form-check-label">Room</label>
                </div>
              </div>
              <div className="col-md-4">
                <label className="form-label">Document Type</label>
                <select className="form-select" value={documentType} onChange={(e) => setDocumentType(e.target.value)}>
                  <option value="photo">Photo</option>
                  <option value="document">Document</option>
                  <option value="virtual">Virtual Tour</option>
                  <option value="video">Video</option>
                </select>
              </div>
            </div>

            <div className="row mb-3">
              <div className="col-md-4">
                <label className="form-label">Unit Type</label>
                <select className="form-select" value={propertyTypeId} onChange={(e) => setPropertyTypeId(e.target.value)}>
                  <option value="">--Select--</option>
                  {unitTypes.map((type) => (
                    <option key={type.id} value={type.id}>{type.name}</option>
                  ))}
                </select>
              </div>
              <div className="col-md-4">
                <label className="form-label">Unit Name</label>
                <select className="form-select" value={propertyId} onChange={(e) => setPropertyId(e.target.value)}>
                  <option value="">--Select--</option>
                  {unitNames.map((unit) => (
                    <option key={unit.id} value={unit.id}>{unit.name}</option>
                  ))}
                </select>
              </div>
            </div>

            {selectedUnit === "Room" && (
              <div className="row mb-3">
                <div className="col-md-4">
                  <label className="form-label">Room Type</label>
                  <select className="form-select" value={roomTypeId} onChange={(e) => setRoomTypeId(e.target.value)}>
                    <option value="">--Select--</option>
                    {roomTypes.map((room) => (
                      <option key={room.HotelRoomConfigID} value={room.HotelRoomConfigID}>
                        {room.HotelRoomConfigType}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            )}

            <div className="row mb-3">
              <div className="col-md-4">
                <label className="form-label">Upload File</label>
                <input type="file" className="form-control" onChange={(e) => setFile(e.target.files[0])} />
              </div>
              <div className="col-md-2 d-flex align-items-end">
                <div className="form-check">
                  <input type="checkbox" className="form-check-input" checked={isDefault === 1} onChange={(e) => setIsDefault(e.target.checked ? 1 : 0)} />
                  <label className="form-check-label">Default</label>
                </div>
              </div>
            </div>

            <div className="row mb-4">
              <div className="col-md-6">
                <label className="form-label">Description</label>
                <textarea className="form-control" value={description} onChange={(e) => setDescription(e.target.value)} maxLength={400} placeholder="Max 400 characters"></textarea>
              </div>
            </div>

            <div className="d-flex justify-content-end gap-2">
              <button type="submit" className="btn btn-success">Submit</button>
              <button type="button" className="btn btn-danger" onClick={() => window.location.reload()}>Reset</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default UploadDocumentsForm;